/**
 * Races a promise against a timer, rejecting with `timeoutMessage` if `promise` hasn't settled
 * within `ms`. Used for network calls in the post-publish critical path that are awaited before
 * `navigate()` — a hung request must reject rather than block publish indefinitely.
 */
export async function withTimeout<T>(promise: Promise<T>, ms: number, timeoutMessage: string): Promise<T> {
	let timer: ReturnType<typeof setTimeout> | undefined;
	// A timer-backed rejection is the standard timeout primitive; the timer is cleared in `finally`
	// when the real promise wins, so it never lingers.
	// oxlint-disable-next-line promise/avoid-new
	const timeout = new Promise<never>((_resolve, reject) => {
		timer = setTimeout(() => reject(new Error(timeoutMessage)), ms);
	});
	try {
		return await Promise.race([promise, timeout]);
	} finally {
		clearTimeout(timer);
	}
}
